/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cal_1_DInputs */

const en_cp_cal_1_d = /** @type {(inputs: Cp_Cal_1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create the workspace, pick a track, invite the lecturer as client.`)
};

const id_cp_cal_1_d = /** @type {(inputs: Cp_Cal_1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat workspace, pilih jalur, undang dosen sebagai klien.`)
};

/**
* | output |
* | --- |
* | "Create the workspace, pick a track, invite the lecturer as client." |
*
* @param {Cp_Cal_1_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cal_1_d = /** @type {((inputs?: Cp_Cal_1_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cal_1_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cal_1_d(inputs)
	return en_cp_cal_1_d(inputs)
});